<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row>
      <v-col class="pt-0">

        <p>Name: {{ user.first_name }} {{ user.last_name }}</p>
        <p class="mb-1">Current Signature:</p>

        <replace-image
          v-if="this.previewUrl !== null"
          :user="user"
          :filename="filename"
          :previewUrl="previewUrl"
          @confirm="showConfirm"
          @triggerFileInput="triggerFileInput"
          @addDropFile="addDropFile"
        />

        <add-image
          v-else
          :user="user"
          @addDropFile="addDropFile"
          @triggerFileInput="triggerFileInput"
        />

        <v-file-input
          ref="signature"
          v-model="file"
          :rules="rules"
          accept="image/*"
          class="d-none"
          @change="checkFile"
        />

        <anchor-confirm-dialog
          ref="confirmDialog"
          :max-width="400"
          title="Do you really want to remove your signature?"
          @cancel="value = null"
          @confirm="removeSignature"
        />

      </v-col>
    </v-row>
    <div class="d-flex mb-4">
      <v-spacer />
      <v-btn
        id="user-form-cancel-btn"
        @click="() => $emit('cancel')"
      >
        Cancel
      </v-btn>
      <v-btn
        id="user-form-save-btn"
        :disabled="!valid || error"
        color="primary"
        class="ml-3"
        @click="submit"
      >
        Save
      </v-btn>
    </div>
  </v-form>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

import AddImage from '@/components/admin/controls/users/forms/signature/AddImage';
import ReplaceImage from '@/components/admin/controls/users/forms/signature/ReplaceImage';


export default {
  components: {
    AddImage,
    ReplaceImage,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      value: null,
      previewUrl: null,
      filename: null,
      valid: false,
      loading: false,
      error: null,
      rules: [
        v => (v && v.type.match(/image.*/) !== null) || 'Not a image',
      ],
      file: null,
    };
  },
  methods: {
    showConfirm() {
      this.$refs.confirmDialog.open();
    },
    removeSignature() {
      const endpoint = `/v1/users/${this.user._id}/signature/remove`;
      this.$requests.delete(endpoint)
        .then(() => {
          this.$toast.success('Signature removed', { timeout: 2000 });
          this.$emit('deleteSignature');
          this.previewUrl = null;
          this.$refs.form.reset();
        })
        .catch(error => {
          this.$toast.error(error, { timeout: 2000 });
        });
    },
    hasSignatureActive() {
      if (this.user.signature && this.user.signature.length > 0 && this.user.signature[0].active) {
        return true;
      }
      return false;
    },
    checkFile() {
      if (!this.file) {
        if (!this.hasSignatureActive()) {
          this.previewUrl = null;
        }
        return;
      }

      if (!this.$refs.form.validate()) {
        this.$toast.error(
          this.$refs.form.inputs[0].errorBucket[0],
          { timeout: 2000 },
        );
      }

      this.previewUrl = URL.createObjectURL(this.file);
      this.filename = this.file.name;
    },
    addDropFile(e) {
      this.file = e.dataTransfer.files[0];
      this.previewUrl = URL.createObjectURL(this.file);
      this.filename = this.file.name;
    },
    submit() {
      this.handleImage();
    },
    dataURItoBlob(dataURI) {
      const dataSplited = dataURI.split(',');

      let bytes = null;
      if (dataSplited[0].indexOf('base64') >= 0) {
        bytes = atob(dataSplited[1]);
      } else {
        bytes = unescape(dataSplited[1]);
      }

      const mime = dataSplited[0].split(':')[1].split(';')[0];
      const max = bytes.length;
      const ia = new Uint8Array(max);

      for (let i = 0; i < max; i += 1) {
        ia[i] = bytes.charCodeAt(i);
      }

      return new Blob([ia], { type: mime });
    },
    resizeImage(file, maxSize) {
      const reader = new FileReader();
      const image = new Image();
      const canvas = document.createElement('canvas');

      const resize = () => {
        let { width, height } = image;

        width *= maxSize / height;
        height = maxSize;

        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);

        const dataUrl = canvas.toDataURL('image/png');

        return this.dataURItoBlob(dataUrl);
      };

      return new Promise(resolve => {
        reader.onload = readerEvent => {
          image.onload = () => resolve(resize());
          image.src = readerEvent.target.result;
        };

        reader.readAsDataURL(file);
      });
    },
    triggerFileInput() {
      this.$refs.signature.$el.querySelector('input').click();
    },
    handleImage() {
      this.resizeImage(this.file, 150)
        .then(data => {
          const params = new FormData();
          params.append('signature', data, this.file.name);

          const endpoint = `/v1/users/${this.user._id}/signature`;
          this.$requests.put(endpoint, params)
            .then(() => {
              this.$toast.success('Signature saved', { timeout: 2000 });
              this.$emit('success');
              this.file = null;
            })
            .catch(error => {
              this.$toast.error(error, { timeout: 2000 });
              this.file = null;
            });
        })
        .catch(error => {
          this.$toast.error(error, { timeout: 2000 });
          this.file = null;
        });
    },
  },
  watch: {
    user(val) {
      if (val.signature === undefined) {
        this.previewUrl = null;
        this.filename = null;
      }
    },
  },
  mounted() {
    if (this.hasSignatureActive()) {
      this.filename = this.user.signature[0].file_name;
      this.previewUrl = `/v1/users/${this.user._id}/file?=${this.user.signature[0].file_name}`;
    }
  },
};
</script>
